export default __webpack_public_path__ + "static/media/head.27bb8ba7.webp";